import { find } from 'lodash';

import { ScoutLatestData } from '@/api/scout';
import { LocationData } from '@/common/types';

type DeviceTrackLocation = Pick<LocationData, 'latitude' | 'longitude' | 'timestamp'>;
type ScoutLocation = Pick<ScoutLatestData, 'position' | 'timestamp'>;

export type DeviceMapLocation = {
    latitude: number;
    longitude: number;
    timestamp: string | null;
};

export const calculateDeviceLocation = ({
    spotterTrack,
    scoutLocation,
    selectedTimestamp,
}: {
    spotterTrack?: DeviceTrackLocation[] | null;
    scoutLocation?: ScoutLocation | null;
    selectedTimestamp?: string | null;
}): DeviceMapLocation | null => {
    const scoutPosition = scoutLocation?.position;

    if (scoutPosition && scoutPosition.latitude != null && scoutPosition.longitude != null) {
        return {
            latitude: scoutPosition.latitude,
            longitude: scoutPosition.longitude,
            timestamp: scoutLocation.timestamp ?? null,
        };
    }

    // all our spotterTrack sources sort most recent first, so find the first one that isn't too late
    const deviceLocation =
        (selectedTimestamp && find(spotterTrack, ({ timestamp }) => timestamp <= selectedTimestamp)) ??
        spotterTrack?.[0];
    if (deviceLocation && deviceLocation.latitude != null && deviceLocation.longitude != null) {
        return {
            latitude: deviceLocation.latitude,
            longitude: deviceLocation.longitude,
            timestamp: deviceLocation.timestamp ?? null,
        };
    }

    return null;
};
